export const SESSION_TOKEN = '@@baleo-shop/token';

export const USE_CART = true;
